import { Component, OnInit,HostListener } from '@angular/core';
import {timerComponent} from "../cheque-book-request/timerComponent";
import {TitleComponent} from "../title/title.component";
import {Router} from "@angular/router";

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',

  styleUrls: ['./disclaimer.component.css']
})
export class DisclaimerComponent implements OnInit {

  window:string='' ;
  display=' ';

  constructor(
    public title : TitleComponent,
    public router: Router

  ) { }

  ngOnInit() {


    //window.open(this.getUrl(/#/disclaimer/), '_blank');
    // window.location = '/#/disclaimer/' + res;
  }


 goToLink(){
    this.router.navigate(['/login']);

  }



}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/disclaimer/disclaimer.component.ts